<mat-form-field class="full-width">

  <mat-label  ssFormLabel></mat-label>
  <ss-email-control></ss-email-control>
  <mat-error  ssFormValidationMessage></mat-error>

</mat-form-field>